module.exports = __webpack_public_path__ + "static/media/battistrada.d1d82d09.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/sounds/battistrada.mp3
// module id = 185
// module chunks = 0